export const meta = {
  title: "よくある質問（FAQ）",
  updatedAt: "2026-05-22",
};

export function Content() {
  return (
    <>
      <p>
        よくあるご質問は <a href="/faq">FAQ ページ</a> に集約しています。
      </p>
      <p>
        プラン・課金・トラブルシューティング・セキュリティに関する質問への
        回答を一覧化していますので、まずはそちらをご確認ください。
      </p>
      <p>
        FAQ で解決しない場合は{" "}
        <a href="/contact">お問い合わせフォーム</a> よりご相談ください。
      </p>
    </>
  );
}
